module.exports = __webpack_public_path__ + "static/img/10.82892e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/10.png
// module id = JQaS
// module chunks = 1